module.exports = __webpack_public_path__ + "8318fc38c1e7acbb09c4bba2a304a054.png";